import React, { useEffect, useState } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import Moment from "react-moment";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../Pagination";

const StudyLabManagementActivities = ({
  activityLoader,
  tableRef,
  onMouseDown,
  getStudyAuditTrials,
  fileId,
  fileActivity,
  fileActivityCount,
  Show,
  Hide,
  Title,
}) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(fileActivityCount / itemsPerPage);
  useEffect(() => {
    if (fileId) {
      getStudyAuditTrials(pageNumber, itemsPerPage);
    }
  }, [fileId, pageNumber, itemsPerPage]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} style={{ width: 900 }} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {activityLoader ? (
            <PageLoader />
          ) : fileActivity?.length === 0 ? (
            <NoDataFoundTable MSG={"Study lab File activity not found!"} />
          ) : (
            <>
              <Table
                id="resizable-table"
                striped
                className="m-0 custom-table"
                ref={tableRef}
              >
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th
                      style={{ width: 100 }}
                      onMouseDown={(e) => onMouseDown(e, 1)}
                    >
                      Activity Type
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Activities</th>
                    <th
                      style={{ width: 200 }}
                      onMouseDown={(e) => onMouseDown(e, 3)}
                    >
                      Previous Value
                    </th>
                    <th
                      style={{ width: 200 }}
                      onMouseDown={(e) => onMouseDown(e, 4)}
                    >
                      Current Value
                    </th>
                    <th
                      style={{ width: 100 }}
                      onMouseDown={(e) => onMouseDown(e, 5)}
                    >
                      Activity By
                    </th>
                    <th
                      style={{ width: 130 }}
                      onMouseDown={(e) => onMouseDown(e, 6)}
                    >
                      Activity Date | Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {fileActivity?.map((item, index) => (
                    <tr>
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td className="text-uppercase">{item?.actionType}</td>
                      <td>{item?.activities}</td>
                      <td>{item?.previousValue}</td>
                      <td>{item?.updatedValue}</td>
                      <td>{item?.activityBy}</td>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {item.createdAt}
                        </Moment>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={fileActivityCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default StudyLabManagementActivities;
